import { useMemo } from 'react';

import type { CategoryNeighbour } from '~/routes/remix-api.product.neighbours';
import type { IslandMode } from '~/ui-rocco/pages/detail-shared';
import { NextProductIslandContent } from './NextProductIslandContent';

/**
 * The island the product page's closing run carries: the next product in the
 * category.
 *
 * Null when the category lookup found nothing after this product, which hands
 * the run back to blanking the island. There is nothing to offer, and the
 * page's enquiry pill has already been left behind by this point.
 *
 * On the `pill` surface so the pill morphs into this rather than having to
 * finish leaving before it can arrive.
 */
export const useNextProductIslandMode = (
    next: CategoryNeighbour | null | undefined,
): IslandMode | null => {
    return useMemo(
        () =>
            next
                ? {
                      kind: 'custom',
                      surface: 'pill',
                      content: <NextProductIslandContent next={next} />,
                  }
                : null,
        [next],
    );
};
